import {useEffect, useState} from 'react';
import LayoutComponent from "../components/LayoutComponent";
import TableComponent from "../components/TableComponent";
import {useApi} from "../provider/ApiProvider";
import CompanyDialog from "../dialogs/CompanyDialog";
import {Button, Popconfirm} from "antd";
import {
    DeleteOutlined,
    RightOutlined,
    CheckCircleOutlined,
    MinusCircleOutlined,
    EditFilled,
    PlusOutlined
} from "@ant-design/icons";
import PlatformDialog from "../dialogs/PlatformDialog";

export default function PlatformsPage(){

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Adı',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Müşteriler Görünsün mü?',
            render: (record) => (
                <div>
                    {record.isShowCustomers ?
                        <CheckCircleOutlined style={{color: 'green', fontSize: '17px'}}/>
                        :
                        <MinusCircleOutlined style={{color: 'red', fontSize: '17px'}}/>}

                </div>
            )

        },

        {
            title: 'Uygulama',
            render: (record) => (
                <div>
                    {record.showApp ?
                        <CheckCircleOutlined style={{color: 'green', fontSize: '17px'}}/>
                        :
                        <MinusCircleOutlined style={{color: 'red', fontSize: '17px'}}/>}

                </div>
            )

        },


        {
            title: 'İşlemler',
            render: (record) => (
                <div>
                    <Popconfirm
                        title="Silmek istediğinize emin misiniz?"
                        onConfirm={() => {deleteRow(record.id, record)}}
                        onCancel={() => {
                            return;
                        }}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button danger><DeleteOutlined/></Button>
                    </Popconfirm>
                    <Button  style={{marginLeft: '4%'}} onClick={() => editDialog(record)}>
                        <EditFilled />
                    </Button>

                </div>
            )
        }

    ];

    const {api} = useApi();
    const [platforms, setPlatforms] = useState({totalCount: 0, items:[]});
    const [dialog, setDialog] = useState({open: false, data: null});

    useEffect(() => {
        load({skip: 0, max: 10});

    }, [])

    async function load(params){
        api.get('/platformRouter/platform/all', params).then(resp => {
            setPlatforms({totalCount: resp.totalCount, items: resp.data})
        })
    }

    function addDialog(){
        setDialog({open: true, data: null});
    }

    function editDialog(data){
        setDialog({open: true, data: data});
    }

    function deleteRow(id, record){
        api.delete("/platformRouter/platform/delete/" + id).then(resp => {
            load();
        }).finally(() => {

        })
    }

    return (
        <LayoutComponent title={"Platformlar"} links={
            [
                {
                    title: 'Platform Listesi',
                    url: '/'
                },

            ]}
                         newButton={<>
                             <Button icon={<PlusOutlined />} onClick={() => addDialog()} type="primary">Ekle</Button>
                         </>}
        >
            <TableComponent
                columns={columns}
                data={platforms}

                clickRow={(data) => editDialog(data)}
            />
            <PlatformDialog
                open={dialog.open}
                data={dialog.data}
                onChange={() => load()}
                onClose={() => setDialog({open: false, data: null})}
            />

        </LayoutComponent>
    )
}
